// Keeps a quick-add form's hidden variant input, price, and button state in sync with its option radios.
class SQuickVariant extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    this.addEventListener('change', (event) => this.#onChange(event), { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #onChange(event) {
    const radio = event.target;
    if (!(radio instanceof HTMLInputElement) || radio.type !== 'radio') return;

    // The hidden input[name="id"] is the source of truth s-product-form submits.
    const variantInput = this.querySelector('input[name="id"]');
    if (variantInput) variantInput.value = radio.value;

    const price = this.querySelector('[data-quick-price]');
    if (price && radio.dataset.price) price.textContent = radio.dataset.price;

    this.#swapImage(radio);

    const button = this.querySelector('button[name="add"]');
    if (button) {
      const available = radio.dataset.available === 'true';
      button.disabled = !available;
      button.textContent = available ? this.dataset.addLabel : this.dataset.soldOutLabel;
    }
  }

  // The image lives in the same product card, outside the form, so look it up from the card root.
  #swapImage(radio) {
    const src = radio.dataset.imageSrc;
    if (!src) return;

    const image = this.closest('article')?.querySelector('img[data-quick-image]');
    if (!(image instanceof HTMLImageElement) || image.getAttribute('src') === src) return;

    if (radio.dataset.imageSrcset) image.srcset = radio.dataset.imageSrcset;
    image.src = src;

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      image.animate([{ opacity: 0.4 }, { opacity: 1 }], { duration: 220, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' });
    }
  }
}

if (!customElements.get('s-quick-variant')) {
  customElements.define('s-quick-variant', SQuickVariant);
}
